import { render, staticRenderFns } from "./d2c.vue?vue&type=template&id=22b9a63c&"
import script from "./d2c.vue?vue&type=script&lang=js&"
export * from "./d2c.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports